import React, { useEffect, useState, useContext } from 'react';
import { BuildPlanContext } from '../../contexts/DTC/DTCContext';
import { dummyCoOps } from '../DummyData';
import styles from '../BuildPlan.module.css';
import BasicRadioBox from '../../shared/Radio/BasicRadioBox';

const SelectCoOp = () => {
    const { state, dispatch } = useContext(BuildPlanContext);
    const { availableCoOps, selectedCoOp } = state;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCoOps = /** async */ () => {
            setLoading(true);
            // DO API THINGS,
            // .THEN res => dispatch(init, res)\
            dispatch({
                type: 'INIT',
                payload: {
                    availableCoOps: dummyCoOps
                }
            });
            setLoading(false);
        };
        fetchCoOps();
    }, []);

    const handleSelect = (e) => {
        const { value } = e.target;
        const found = availableCoOps.find((co) => co.id === value);

        if (!found) return;

        dispatch({
            type: 'INIT',
            payload: {
                selectedCoOp: found
            }
        });
    };

    if (loading) return null;

    return (
        <>
            <h3 className='h6'>Are you a member of a co-op?</h3>
            <p>You may be eligible for plans specific to your membership.</p>
            <div className={styles.flex}>
                {availableCoOps.map((co, i) => {
                    return (
                        // <button className="btn-secondary" value={o.value}>{o.display}</button>
                        <BasicRadioBox
                            key={`${co.id}-${i}`}
                            index={i}
                            formGroupId={`coOp-${co.id}`}
                            inputId={co.id}
                            value={co.id}
                            onChange={handleSelect}
                            checked={selectedCoOp?.id === co.id}
                        >
                            {co.name}
                        </BasicRadioBox>
                    );
                })}
            </div>
        </>
    );
};

export default SelectCoOp;
